import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon/layers-1-1</title><path d="M32 8.6L16 1 0 8.6l16 7.6 16-7.6zm0 7.4l-3.8-1.8L16 20 3.8 14.2 0 16l16 7.6L32 16zm-3.8 5.6L16 27.4 3.8 21.6 0 23.4 16 31l16-7.6-3.8-1.8z" fill="#FFF" fillRule="evenodd" /></svg>);